<script setup>
import { computed } from "vue";

const props = defineProps({
	data: {
		type: Object,
		required: true,
	},
	productsInBasket: {
		type: Object,
	},
});

const active = computed(() => {
	if (!props.productsInBasket) return false;

	let isSwatchActive = false;
	props.productsInBasket.map((product) => {
		if (product.id === props.data.id) isSwatchActive = true;
	});

	return isSwatchActive;
});

const borderColour = computed(() => {
	if (active.value) return "#081F40";
	let colour = props.data.hex;

	props.data.hex.map((hex) => {
		if (hex.toLowerCase() === "#ffffff") {
			colour = "#E2E2E2";
		}
	});

	return typeof colour === 'object' ? colour[0] : colour;
});
</script>

<template>
	<div
		class="e-swatch u-pos-rel"
		:style="{ border: '2px solid ' + borderColour }"
	>
		<div class="u-flex e-swatch__wrapper">
			<span
				class="e-swatch__inner e-swatch__inner--split u-block"
				:class="{ 'e-swatch__inner--active': active }"
				:style="{ background: data.hex[0] }"
			></span>

			<span
				class="e-swatch__inner e-swatch__inner--split u-block"
				:class="{ 'e-swatch__inner--active': active }"
				:style="{ background: data.hex[1] ? data.hex[1] : data.hex[0] }"
			></span>
		</div>

		<span class="e-swatch__label">{{ data.name }}</span>
	</div>
</template>
